import script from "./ModalFormularioV2.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFormularioV2.vue?vue&type=script&setup=true&lang=js"

import "./ModalFormularioV2.vue?vue&type=style&index=0&id=45f292b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45f292b0"]])

export default __exports__